import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { loadAppUser } from '../actions/AppUserActions';
import { loadAttributes, loadAttributesHubless } from '../actions/AttributeActions';
import { loadPortalSetting } from '../actions/PortalSettingsActions';
import { loadHomePageOptions, loadDefaultHomePage } from '../actions/NavConfigActions';
import BasicInfo from '../components/BasicInfo';
import PortalSettingsKeys from '../constants/PortalSettingsKeys';
import { getAppUser } from '../selectors/AppUserSelector';
import { getUserIdFromAuth } from '../selectors/AuthSelector';
import { getGatesFromAuth, getScopesFromAuth, isApplicationHubless } from '../selectors/AuthSelector';
import UserPreferencesPage from './UserPreferencesPage';
import UserPreferencesStickySave from './UserPreferencesStickySave';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class BasicInfoContainer extends Component {
  constructor(...args) {
    super(...args);
    this.loadAttributesMaybeHubless = () => {
      const {
        isHubless,
        userId
      } = this.props;
      if (!isHubless) {
        this.props.loadAttributes();
        this.props.loadPortalSetting(PortalSettingsKeys.gdprUnsubscribeLinkEnabled);
        this.props.loadHomePageOptions();
        this.props.loadDefaultHomePage();
        if (userId) {
          this.props.loadAppUser({
            userId
          });
        }
      } else {
        this.props.loadAttributesHubless();
      }
    };
  }
  componentDidMount() {
    this.loadAttributesMaybeHubless();
  }
  render() {
    const {
      appUser,
      isHubless,
      gates,
      scopes
    } = this.props;
    return /*#__PURE__*/_jsxs(UserPreferencesPage, {
      children: [/*#__PURE__*/_jsx(BasicInfo, {
        gates: gates,
        isHubless: isHubless,
        scopes: scopes,
        seatNames: appUser.seatNames
      }), /*#__PURE__*/_jsx(UserPreferencesStickySave, {})]
    });
  }
}
BasicInfoContainer.propTypes = {
  isHubless: PropTypes.bool.isRequired,
  loadAttributes: PropTypes.func.isRequired,
  loadAttributesHubless: PropTypes.func.isRequired,
  loadPortalSetting: PropTypes.func.isRequired,
  loadHomePageOptions: PropTypes.func.isRequired,
  loadDefaultHomePage: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    appUser: getAppUser(state),
    gates: getGatesFromAuth(state),
    isHubless: isApplicationHubless(state),
    scopes: getScopesFromAuth(state),
    userId: getUserIdFromAuth(state)
  };
};
const mapDispatchToProps = {
  loadAppUser,
  loadAttributes,
  loadAttributesHubless,
  loadPortalSetting,
  loadHomePageOptions,
  loadDefaultHomePage
};
export default connect(mapStateToProps, mapDispatchToProps)(BasicInfoContainer);